var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":""}},[(_vm.dashUrl)?_c('iframe',{attrs:{"src":_vm.dashUrl,"allowtransparency":"","frameborder":"0"},on:{"load":_vm.frameLoaded}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }